import type { ChurnDimension, ChurnWarningV2TemplateArgs } from '../../../server/dto/insight-dto.ts';

export const churnV2TooltipKey: Partial<Record<ChurnDimension, string>> = {
    d2_cadence: 'churn_v2_tooltip__d2_cadence',
    d3_annual: 'churn_v2_tooltip__d3_annual',
    d4_seasonal: 'churn_v2_tooltip__d4_seasonal',
    d5_revenue: 'churn_v2_tooltip__d5_revenue',
    d6_momentum: 'churn_v2_tooltip__d6_momentum',
};

function convertToMonths(days: number): number {
    return Math.ceil(days / 30);
}

export function churnV2TooltipLength(dim: ChurnDimension, args: ChurnWarningV2TemplateArgs): number {
    switch (dim) {
        case 'd2_cadence':
            return convertToMonths(args.d2_period_length ?? 30);
        case 'd4_seasonal':
            return args.d4_period_length ?? 3;
        case 'd6_momentum':
            return 6;
        default:
            return 12; // d3_annual, d5_revenue
    }
}

/**
 * The single dimension a churn v2 card describes: the one the EUR figure was computed over.
 *
 * Prefers `revenue_impact_dimension`, and only when it has tooltip copy. Falls back to the scoring
 * ranking for batches that predate it, skipping dimensions with no period of their own.
 */
export function churnV2CardDimension(args: ChurnWarningV2TemplateArgs): ChurnDimension {
    return (
        [
            args.revenue_impact_dimension,
            args.top_dimension_1,
            args.top_dimension_2,
            args.top_dimension_3,
        ].find((dim): dim is ChurnDimension => !!dim && dim in churnV2TooltipKey) ?? args.top_dimension_1
    );
}
